"use client";

import { SearchResultsBanner } from "@faire/retailer-visitor-shared/components/Banners/SearchBanners/SearchResultsBanner";
import { IBannerData } from "@faire/retailer-visitor-shared/lib/bannerUtils";
import { noOpReturningArrayOfType } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ViewState/searchPageDataUtil";
import { ISearchCatNavBannersResponse } from "@faire/web-api--source/indigofair/data/ISearchCatNavBannersResponse";
import React, { createContext, ReactNode, useContext } from "react";

interface SearchPageBannersData {
  bannersResponse: ISearchCatNavBannersResponse | undefined;
  bannersDisplayData: IBannerData<SearchResultsBanner>[];
  replacedProductTilesCount: number;
  displayableBannersWithAdjustedRow: (
    itemsPerRow: number,
    itemLength: number
  ) => IBannerData<SearchResultsBanner>[];
}

const INITIAL_SEARCH_BANNERS_DATA: SearchPageBannersData = {
  bannersResponse: undefined,
  bannersDisplayData: [],
  replacedProductTilesCount: 0,
  displayableBannersWithAdjustedRow: noOpReturningArrayOfType<
    IBannerData<SearchResultsBanner>
  >,
};

const SearchBannersDataContext = createContext<SearchPageBannersData>(
  INITIAL_SEARCH_BANNERS_DATA
);

export const SearchPageBannersDataContextProvider = ({
  children,
  searchBannersData,
}: {
  children: ReactNode;
  searchBannersData: SearchPageBannersData;
}) => {
  return (
    <SearchBannersDataContext.Provider value={searchBannersData}>
      {children}
    </SearchBannersDataContext.Provider>
  );
};

export const useSearchPageBannersDataContext = () => {
  const value = useContext(SearchBannersDataContext);
  if (value === INITIAL_SEARCH_BANNERS_DATA) {
    throw new Error(
      "useSearchPageBannersDataContext must be used within a SearchPageBannersDataContextProvider"
    );
  }
  return value;
};
